module.exports = __webpack_public_path__ + "assets/img/Type E (40).b39ee247.jpg";